import Switch, { SiriusSwitchProps } from './siriusSwitch';
export { Switch };
export default Switch;
